import actions from './constants';

export const createDatasetNotificationSuccess = (name, update) => ({
  type: actions.CREATE_DATASET_NOTIFICATION_SUCCESS,
  name,
  update,
});

export const createDatasetNotificationError = (error) => ({
  type: actions.CREATE_DATASET_NOTIFICATION_ERROR,
  error,
});
